import * as React from "react";
import { Controller, useFormContext, RegisterOptions } from "react-hook-form";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { Box, Divider, Grid, Typography } from "@mui/material";

interface OptionType {
  label: string;
  value: string | number;
  disabled?: boolean;
}

interface MCheckboxProps {
  name: string;
  options: OptionType[];
  label?: string;
  validation?: RegisterOptions;
  multiple?: boolean;
  orientation?: "horizontal" | "vertical";
  columns?: number;
  disabled?: boolean;
}
const MCheckbox: React.FC<MCheckboxProps> = ({
  name,
  options,
  label,
  validation,
  multiple = true,
  orientation = "vertical",
  columns = 1,
  disabled,
}) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      rules={validation}
      render={({ field, fieldState }) => (
        <Box>
          {label && <Typography variant="sectionTitle">{label}</Typography>}
          {label && <Divider />}
          <FormGroup row={orientation === "horizontal"}>
            <Grid container spacing={1}>
              {options.map((option) => (
                <Grid item xs={12 / columns} key={option.value}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={
                          Array.isArray(field.value)
                            ? field.value.includes(option.value)
                            : field.value === option.value
                        }
                        onChange={(event) => {
                          if (multiple) {
                            const newValue = event.target.checked
                              ? [...(field.value || []), option.value]
                              : (field.value || []).filter(
                                  (val: any) => val !== option.value
                                );
                            field.onChange(newValue);
                          } else {
                            field.onChange(
                              event.target.checked ? option.value : ""
                            );
                          }
                        }}
                        disabled={disabled || option.disabled}
                      />
                    }
                    label={option.label}
                  />
                </Grid>
              ))}
            </Grid>
          </FormGroup>
          {fieldState.error && (
            <p style={{ color: "red" }}>{fieldState.error.message}</p>
          )}
        </Box>
      )}
    />
  );
};

export default MCheckbox;
